import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileHeader from './MobileHeader';
import MobileBottomNav from './MobileBottomNav';
import MobileDrawer from './MobileDrawer';
import { API_ROOT } from '@/config';

interface MobileLayoutProps {
  children: React.ReactNode;
  title?: string;
  showHeader?: boolean;
  showBottomNav?: boolean;
  showBack?: boolean;
  showMenu?: boolean;
  headerTransparent?: boolean;
  rightAction?: React.ReactNode;
  onBack?: () => void;
  backTo?: string;
}

interface UserInfo {
  email: string;
  first_name: string;
  surname: string;
  company_name?: string;
  user_type?: string;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  title,
  showHeader = true,
  showBottomNav = false,
  showBack = false,
  showMenu = true,
  headerTransparent = false,
  rightAction,
  onBack,
  backTo,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch(`${API_ROOT}/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          setUserInfo(data);
        }
      } catch (error) {
        console.error('Failed to fetch user info:', error);
      }
    };

    fetchUserInfo();
  }, []);

  const userType = (localStorage.getItem('userType') as 'brand' | 'creator') || 'brand';

  return (
    <div className="mobile-app">
      {showHeader && (
        <MobileHeader
          title={title}
          showBack={showBack}
          showMenu={showMenu && !showBack}
          onMenuClick={() => setDrawerOpen(true)}
          onBack={onBack}
          backTo={backTo}
          rightAction={rightAction}
          transparent={headerTransparent}
        />
      )}

      <main className={`mobile-main ${!showBottomNav ? 'no-bottom-nav' : ''}`}>
        {children}
      </main>

      {showBottomNav && <MobileBottomNav userType={userType} />}

      <MobileDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        userInfo={userInfo}
      />
    </div>
  );
};

export default MobileLayout;
